export enum RadioSize {
  xsmall = 'xsmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
}
export type RadioSizeUnion = keyof typeof RadioSize;
export type BoxRadioSizeUnion = Exclude<RadioSizeUnion, 'small'>;
export type DefaultRadioSizeUnion = Exclude<RadioSizeUnion, 'xsmall'>;
